export const getDomainFromWindow = () => {
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }
    return null;
};

// Ref: https://stackoverflow.com/a/63627688
export const openInNewTab = (url: string): void => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
};
